import _ from 'lodash'

export default (collections) ->
	{opportunities} = collections

	numberOfOpportunities: (obj, args, context, info) ->
		opportunities.count accountID: obj.id
